import { render, staticRenderFns } from "./RendimientoEvento.vue?vue&type=template&id=5ec8d75c&"
import script from "./RendimientoEvento.vue?vue&type=script&lang=js&"
export * from "./RendimientoEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports